import { ForeAftEnum } from "open-vessel-definition";
/** Gets the CG at the AFT or FWD of the composed/single bay
 * @param idRef The composed/single bay id
 * @param posRef The position to get the CG that we want to obtain
 * @param lcgVcgTcgAndPairings The calculated LCGs, VCGs and TCGs
 */
export function findReferenceLcg(idRef, posRef, lcgVcgTcgAndPairings) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const idParts = idRef.split("-");
    const [bayRefDir, bayRefPair] = idParts;
    const { lcgsBy20Bay } = lcgVcgTcgAndPairings;
    // Use ?? (not ||) so an LCG of 0 is not treated as missing
    if (posRef === ForeAftEnum.AFT) {
        return Math.min((_b = (_a = lcgsBy20Bay[bayRefDir]) === null || _a === void 0 ? void 0 : _a.minAftLcg) !== null && _b !== void 0 ? _b : Infinity, (_d = (_c = lcgsBy20Bay[bayRefPair]) === null || _c === void 0 ? void 0 : _c.minAftLcg) !== null && _d !== void 0 ? _d : Infinity);
    }
    else {
        return Math.max((_f = (_e = lcgsBy20Bay[bayRefDir]) === null || _e === void 0 ? void 0 : _e.maxForeLcg) !== null && _f !== void 0 ? _f : -Infinity, (_h = (_g = lcgsBy20Bay[bayRefPair]) === null || _g === void 0 ? void 0 : _g.maxForeLcg) !== null && _h !== void 0 ? _h : -Infinity);
    }
}
/** True if the composed/single bay has LCGs (empty bays don't, so they take no space) */
export function bayHasLcgs(idRef, lcgVcgTcgAndPairings) {
    return (Number.isFinite(findReferenceLcg(idRef, ForeAftEnum.AFT, lcgVcgTcgAndPairings)) &&
        Number.isFinite(findReferenceLcg(idRef, ForeAftEnum.FWD, lcgVcgTcgAndPairings)));
}
